<script setup lang="ts">
type Props = {
  emoji: string;
  paragraph: 1 | 2;
};

const props = defineProps<Props>();
</script>

<template>
  <div class="d-flex flex-column justify-start align-start">
    <p class="mb-2">
      <span>{{ props.emoji }}</span>
      <span class="text-subtitle-2">{{
        ` ${$t(`email.candidate.share.subtitle_${props.paragraph}.title`)}`
      }}</span>
    </p>
    <ul class="list text-body-3">
      <li v-for="number in 3" :key="`bullet-${number}`">
        {{
          $t(`email.candidate.share.subtitle_${props.paragraph}.point_${number}`, { gender: 'm' })
        }}
      </li>
    </ul>
  </div>
</template>
